export default {
  props: {
    dropdownHeaderClass: Array,
  },
}
